var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGear = function SvgGear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m23.528 10.345-.622-1.08a1.913 1.913 0 0 0-2.609-.704v0a1.904 1.904 0 0 1-2.609-.678 1.83 1.83 0 0 1-.256-.915v0A1.914 1.914 0 0 0 15.519 5h-1.254a1.904 1.904 0 0 0-1.904 1.913v0a1.913 1.913 0 0 1-1.913 1.886 1.83 1.83 0 0 1-.915-.257v0a1.913 1.913 0 0 0-2.609.705l-.668 1.098a1.913 1.913 0 0 0 .695 2.61v0a1.913 1.913 0 0 1 0 3.313v0a1.904 1.904 0 0 0-.695 2.6v0l.631 1.088a1.913 1.913 0 0 0 2.61.742v0a1.895 1.895 0 0 1 2.599.696c.164.277.252.593.256.915v0c0 1.056.856 1.913 1.913 1.913h1.254a1.913 1.913 0 0 0 1.913-1.904v0a1.904 1.904 0 0 1 1.913-1.913c.322.009.636.097.915.256v0a1.913 1.913 0 0 0 2.61-.695v0l.658-1.099a1.904 1.904 0 0 0-.696-2.608v0a1.904 1.904 0 0 1-.695-2.61c.166-.289.406-.529.695-.695v0a1.913 1.913 0 0 0 .696-2.6v0-.008Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.896,
    cy: 14.611,
    r: 2.636,
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgGear;